import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const PORTRAIT_URL = "https://customer-assets-lxgj4vgw.emergentagent.net/job_142de766-7447-4fb5-b920-10398996bff4/artifacts/0pp8u9ck_fondo-cyborg-8k-vertical.webp";

const LoginPage = () => {
  const handleGoogleLogin = () => {
    const redirectOrigin = process.env.REACT_APP_FRONTEND_URL || window.location.origin;
    const redirectUrl = redirectOrigin.replace(/\/$/, '') + '/';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="relative w-full min-h-screen overflow-hidden bg-[#0A0A0A] flex items-center justify-center" data-testid="login-page">
      {/* Background portrait */}
      <div className="absolute inset-0">
        <img
          src={PORTRAIT_URL}
          alt="Alivan"
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/80 to-black/60" />
        
        {/* Red glow effects */}
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-neon-red/20 blur-3xl rounded-full" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-neon-red/10 blur-3xl rounded-full" />
      </div>

      {/* Login Card */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="relative z-10 max-w-md w-full mx-6"
      >
        <div className="backdrop-blur-xl bg-black/60 border border-neon-red/30 p-10 shadow-[0_0_40px_rgba(255,0,51,0.2)]">
          {/* Alivan text logo */}
          <div className="text-center mb-8">
            <motion.h1
              initial={{ letterSpacing: '0.5em', opacity: 0 }}
              animate={{ letterSpacing: '0.2em', opacity: 1 }}
              transition={{ duration: 1.5, delay: 0.3 }}
              className="font-outfit text-5xl font-bold text-white mb-3"
              data-testid="login-title"
            >
              ALIVAN
            </motion.h1>
            <motion.div
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 1, delay: 0.8 }}
              className="h-[1px] bg-neon-red mx-auto w-24 mb-4"
            />
            <p className="font-jetbrains text-sm text-white/60 tracking-wider">
              ASISTENTE DE IA CIBERNÉTICA
            </p>
          </div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.2, duration: 0.8 }}
            className="space-y-6"
          >
            <p className="font-jetbrains text-center text-white/70 text-sm leading-relaxed">
              Inicia sesión para acceder a tu compañera de IA personal
            </p>

            <button
              onClick={handleGoogleLogin}
              data-testid="google-login-button"
              className="w-full px-6 py-4 bg-white text-black font-outfit font-semibold hover:bg-white/90 transition-all duration-300 flex items-center justify-center gap-3 shadow-[0_0_20px_rgba(255,255,255,0.15)] hover:shadow-[0_0_30px_rgba(255,255,255,0.25)]"
            >
              <svg width="20" height="20" viewBox="0 0 24 24">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
              </svg>
              Continuar con Google
            </button>

            <p className="font-jetbrains text-center text-white/40 text-xs">
              Al continuar, aceptas conectarte con tu asistente personal
            </p>

            <div className="flex items-center justify-center gap-6 pt-2">
              <Link
                to="/privacy"
                data-testid="login-footer-privacy"
                className="font-jetbrains text-[11px] uppercase tracking-widest text-white/50 hover:text-neon-red transition-colors"
              >
                Privacidad
              </Link>
              <span className="w-1 h-1 rounded-full bg-white/20" />
              <Link
                to="/terms"
                data-testid="login-footer-terms"
                className="font-jetbrains text-[11px] uppercase tracking-widest text-white/50 hover:text-neon-red transition-colors"
              >
                Términos
              </Link>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default LoginPage;
